var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import { useSelector } from "react-redux";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import _ from "underscore";
export var ExchangeSelect = [
    { value: "NSE", display: "NSE" },
    { value: "BSE", display: "BSE" },
];
export var DefaultExchange = function () {
    var _a = useSelector(function (state) { return state.postLogin.IndexDetails; }, _.isEqual), indexList = _a.data, loader = _a.loader, errorData = _a.errorData;
    var _b = __read(React.useState(false), 2), deleteToast = _b[0], setDeleteToast = _b[1];
    var _c = __read(useState({
        display: indexList.defExc,
        value: indexList.defExc,
    }), 2), defaultExchangeSelect = _c[0], setDefaultExchangeSelect = _c[1];
    var ExchangeApply = function (exchange) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                exc: exchange,
            };
            di.basicProfile
                .defaultExchangeData(payload)
                .then(function (data) {
                setDeleteToast(true);
            })
                .catch(function (err) {
                console.log(err);
            });
            return [2 /*return*/];
        });
    }); };
    React.useEffect(function () {
        setDefaultExchangeSelect({
            display: indexList.defExc,
            value: indexList.defExc,
        });
    }, [indexList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: deleteToast, setShow: setDeleteToast, position: "middle-center", message: "Default Exchange Selected Succesfully" }),
        React.createElement("div", { className: "grid-2" },
            React.createElement("div", { className: "grid-2 gap-15 mb-hidden nse-bse-checkbox-block-desktop" },
                React.createElement("div", { className: "accordiancheckbox common-checkbox" },
                    React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox common-checkbox-custom" },
                        React.createElement("div", { className: "checkbox" },
                            React.createElement("div", { className: "form-check ps-0" },
                                React.createElement(Checkbox, { list: ExchangeSelect[0], name: "placeorder", onChange: function () {
                                        setDefaultExchangeSelect(ExchangeSelect[0]);
                                    }, className: "common-checkbox-new", selected: defaultExchangeSelect.value }))))),
                React.createElement("div", { className: "accordiancheckbox common-checkbox-new common-checkbox default-exchange-checkbox" },
                    React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox common-checkbox-custom" },
                        React.createElement("div", { className: "checkbox" },
                            React.createElement("div", { className: "form-check ps-0" },
                                React.createElement(Checkbox, { list: ExchangeSelect[1], name: "placeorder", onChange: function () {
                                        setDefaultExchangeSelect(ExchangeSelect[1]);
                                    }, className: "common-checkbox-new", selected: defaultExchangeSelect.value })))))),
            React.createElement("div", { className: "setting-content-btn default-exchange-btn-block mb-hidden mgl-30" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", className: "small-edbutton", value: "Apply", disabled: !defaultExchangeSelect.value, onClick: function () {
                        return ExchangeApply(defaultExchangeSelect.value.toString());
                    } })))));
};
